import styled from "styled-components";
import {RegisterButtonDefaultBox} from "./register-button.default.box";
import {baseColors} from "../../../../../themes/definitions/mrgreen/base-colors";

export const RegisterButtonMrGreenBox = styled(RegisterButtonDefaultBox)`
  border: none;
  background: ${baseColors.base04};
  color: ${({theme}) => theme.colors.textDark};
  transition: all 0.2s ease-in-out, border 0s linear;

  &:hover {
    background: none;
    background-color: ${({theme}) => theme.colors.backgroundDark};
    color: ${baseColors.gold};
    border: 2px solid ${baseColors.gold};
    > span {
      background: ${baseColors.gold};
      background: ${baseColors.base04};
      background-size: 100%;
      -webkit-background-clip: text;
      -moz-background-clip: text;
      -webkit-text-fill-color: transparent;
      -moz-text-fill-color: transparent;
    }
  }


`